import { ky } from './client'

/**
 * Saves a list of plans.
 *
 * @param {Array<Plan>} plans - The list of plans to upload.
 * @returns
 */
export const uploadPlans = (plans) => {
  return ky.post('plans/bulk', {
    json: plans
  })
}

/**
 *
 * @param {*} planId
 * @param {*} updateData
 * @returns
 */
export const updatePlanById = (planId, updateData) => {
  return ky.put(`plans/${planId}`, {
    json: updateData,
    customErrorMessage: 'Error updating plan. Please try again.',
    showErrorToast: true
  })
}
